const USER_KEY = 'uxuk_user'
const MID_KEY = 'uxuk_mid'
const RAND_PWD_KEY = 'uxuk_rand_pwd'
const LAT_KEY = 'uxuk_lat'
const LNG_KEY = 'uxuk_lng'

;(function cleanupOldKeys() {
  if (localStorage.getItem('token')) {
    localStorage.removeItem('token')
  }
  if (localStorage.getItem('username')) {
    localStorage.removeItem('username')
  }
})()

export function getMid() {
  return localStorage.getItem(MID_KEY) || ''
}

export function setMid(mid) {
  localStorage.setItem(MID_KEY, mid)
}

export function getRandPassword() {
  return localStorage.getItem(RAND_PWD_KEY) || ''
}

export function setRandPassword(pwd) {
  localStorage.setItem(RAND_PWD_KEY, pwd)
}

export function getUserInfo() {
  const raw = localStorage.getItem(USER_KEY)
  try {
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

export function setUserInfo(info) {
  localStorage.setItem(USER_KEY, JSON.stringify(info || {}))
}

export function removeUserInfo() {
  localStorage.removeItem(USER_KEY)
}

export function isLoggedIn() {
  return !!getMid() && !!getRandPassword()
}

export function logout() {
  removeUserInfo()
  localStorage.removeItem(MID_KEY)
  localStorage.removeItem(RAND_PWD_KEY)
}

export function getLat() {
  return localStorage.getItem(LAT_KEY) || ''
}

export function setLat(lat) {
  localStorage.setItem(LAT_KEY, lat)
}

export function getLng() {
  return localStorage.getItem(LNG_KEY) || ''
}

export function setLng(lng) {
  localStorage.setItem(LNG_KEY, lng)
}

export function fixImgUrl(url) {
  if (!url) return ''
  if (url.startsWith('data:')) return url
  if (url.startsWith('http')) return url
  if (url.startsWith('/')) return 'https://test.uxuk.net' + url
  return url
}
